export default "__VITE_ASSET__De_88zj1__"